var objectToString = {}.toString;
var DATE_STRING = "[object Date]";

export default function isDate(value) {
    return objectToString.call(value) === DATE_STRING;
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@telerik/kendo-intl/dist/es/common/is-date.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/is-date.js
// module chunks = vendor